import React, {createContext, useContext, useEffect, useState} from "react";
import { eventGet, exchangeKeyWithHeaders } from "../../../../api/player";
import Preloader from "../components/Preloader";
import tokenStorage from "../../../../player/js/tokenStorage";
import { HEADER_CLIENT_ACCESS_TOKEN } from "../../../../player/js/api";
import { useLocaleContext } from "../../../../platform/src/context/LocaleContext";

export const EventContext = createContext(null);

export const EventProvider = ({watchKey, showPreloader = false, children}) => {
    const { setEventKey: changeLocaleEventKey, isLoadingLocale } = useLocaleContext();
    const [event, setEvent] = useState(null);
    const [isPreloader, setPreloader] = useState(false);
    const [eventKey, setEventKey] = useState(null);

    const getEventKey = async (watchKey) => {
        try {
            const { data, headers } = await exchangeKeyWithHeaders(watchKey);
            const { eventKey } = data;

            tokenStorage.setEventKey(eventKey);
            tokenStorage.set(headers[HEADER_CLIENT_ACCESS_TOKEN]);

            changeLocaleEventKey(eventKey);
            setEventKey(eventKey);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (!watchKey) {
            return;
        }

        getEventKey(watchKey);
    }, [watchKey]);

    useEffect(() => {
        setPreloader(showPreloader);
    }, [showPreloader]);

    useEffect(async () => {
        if (!eventKey) {
            setEvent(null);
            return;
        }

        try {
            const event = await eventGet(eventKey);
            setEvent(event);
        } catch (e) {
            console.error(e);
            setEvent(false);
        }
    }, [eventKey]);

    if (event === null || isPreloader || isLoadingLocale) {
        return <Preloader />
    }

    if (event === false) {
        return <LoadingMessage>Событие не найдено</LoadingMessage>
    }

    const context = {
        event,
        setEvent,
        watchKey,
        eventKey
    };

    return (
        <EventContext.Provider value={context}>
            {children}
        </EventContext.Provider>
    );
}

export const useEventContext = () => useContext(EventContext);

